import axios from 'axios';

import { SineHeader } from '../../shared/types';
import apiVersionService from './apiVersion.service';

function startsWith(haystack = '', needle = '') {
  return haystack.indexOf(needle) === 0;
}

const webCheckinApiVersionInterceptor = axios.interceptors.response.use((response) => {
  if (startsWith(response.config.url, window.env.REACT_APP_SINE_WEB_CHECK_IN_API_ENDPOINT)) {
    apiVersionService.setApiVersion('web-check-in', response.headers[SineHeader.X_SINE_VERSION] || 'Unknown');
    axios.interceptors.response.eject(webCheckinApiVersionInterceptor);
  }
  return response;
});

const coreApiVersionInterceptor = axios.interceptors.response.use((response) => {
  if (startsWith(response.config.url, window.env.REACT_APP_SINE_CORE_API_ENDPOINT)) {
    apiVersionService.setApiVersion('core', response.headers[SineHeader.X_SINE_VERSION] || 'Unknown');
    axios.interceptors.response.eject(coreApiVersionInterceptor);
  }
  return response;
});
